<template>
    <div class="form-content">
        <div class="logo with-text" v-if="lambda.logoText != ''">
            <img :src="lambda.logo" alt="">
            <span>{{ lambda.logoText }}</span>
        </div>
        <div class="logo" v-else>
            <img src="/images/auh_logo.jpg" alt="logo"
                 style="width: 70%; height: auto; margin-top:2rem"/>
        </div>
        <div class="form-content-inner">

            <div class="or"><span>Нэвтрэх</span></div>

<!--            <h2>{{ lang.loginTitle }}</h2>-->
            <p class="login-description">Та өөрийн нэвтрэх нэр, нууц үгийг ашиглан нэвтэрнэ үү!</p>
            <form v-on:submit.prevent="onSubmit" id="authForm" method="post" class="login-form">
                <div class="form-element input">
                    <input type="text" v-model="credentials.login" :disabled="loading"
                           :placeholder="lang.username">
                    <span class="icon user"></span>
                </div>
                <div class="form-element input">
                    <input type="password" v-model="credentials.password" :disabled="loading"
                           :placeholder="lang.password">
                    <span class="icon pass"></span>
                </div>

                <div></div>

                <div class="form-element input" style="display: flex">
                    <div id="kb-captcha-image"
                         class="inline"
                         selectable="False">
                    </div>

                    <input type="text" id="kb-captcha" v-model="local_captcha" :disabled="loading"
                           placeholder="Captcha оруулна уу">
                </div>

                <div></div>

                <div class="form-element login-btn">
                    <button id="submit" class="button" :disabled="loading">
                        <span id="submitTxt">{{ lang.login }}</span>
                        <span class="loader">
                        <div class="sk-fading-circle" v-if="loading">
                            <div class="sk-circle1 sk-circle"></div>
                            <div class="sk-circle2 sk-circle"></div>
                            <div class="sk-circle3 sk-circle"></div>
                            <div class="sk-circle4 sk-circle"></div>
                            <div class="sk-circle5 sk-circle"></div>
                            <div class="sk-circle6 sk-circle"></div>
                            <div class="sk-circle7 sk-circle"></div>
                            <div class="sk-circle8 sk-circle"></div>
                            <div class="sk-circle9 sk-circle"></div>
                            <div class="sk-circle10 sk-circle"></div>
                            <div class="sk-circle11 sk-circle"></div>
                            <div class="sk-circle12 sk-circle"></div>
                        </div>
                    </span>
                    </button>
                </div>
            </form>

            <div id="msg">
                <div v-if="isSuccess" class="success">{{ lang.loginSuccess }}</div>
                <div v-if="isError" class="error">{{ lang.loginError }}</div>
                <div v-if="isCaptchaError" class="error">Captcha таарахгүй байна</div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: "kb-login",
    data() {
        return {
            loading: false,
            isSuccess: false,
            isError: false,
            isCaptchaError:false,
            credentials: {
                login: null,
                password: null
            },
            lambda: window.lambda,
            windowsd: window.lambda.windowslink,
            androidd: window.lambda.androidlink,
            captcha:null,
            local_captcha:null,
        }
    },
    computed: {
        lang() {
            const labels = ['loginError', 'loginSuccess', 'downloadAppHere', 'login', 'password', 'username', 'loginTitle',
                'pleaseLogInUsingYourRegUnamePassword',
            ];
            return labels.reduce((obj, key, i) => {
                obj[key] = this.$t('user.' + labels[i]);
                return obj;
            }, {});
        },
    },
    mounted(){
        this.generate();
    },
    methods: {
        generate() {
            this.local_captcha=null;
            // Clear old input
            document.getElementById("kb-captcha").value = "";

            // Access the element to store
            // the generated captcha
            let captchaImage = document.getElementById("kb-captcha-image");
            let uniquechar = "";

            const randomchar =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

            // Generate captcha for length of
            // 5 with random character
            for (let i = 1; i < 5; i++) {
                uniquechar += randomchar.charAt(
                    Math.random() * randomchar.length)
            }

            // Store generated input
            captchaImage.innerHTML = uniquechar;
            this.captcha = uniquechar;
        },
        onSubmit() {
            this.isSuccess = false;
            this.isError = false;
            this.isCaptchaError=false;
            if(this.captcha!=this.local_captcha)
            {
                this.isCaptchaError = true;
            }
            else {
                if (!this.loading) {
                    this.loading = true;
                    axios
                        .post('/auth/login', this.credentials)
                        .then(({data}) => {
                            setTimeout(() => {
                                this.loading = false;
                                if (data.status) {
                                    this.isSuccess = true;
                                    setTimeout(() => {
                                       console.log(data)
                                         window.location = data.path;
                                    }, 600);
                                } else {
                                    this.isError = true;
                                    this.errMsg=data.msg;
                                }
                            }, 1000);
                        })
                        .catch((e) => {
                            setTimeout(() => {
                                this.loading = false;
                                this.isError = true;
                            }, 1000);
                        });
                }
            }
        },
    }
}
</script>
